export const indexShopTitles = (shops) => new Map((shops ?? []).map((shop) => [shop.shortId, shop.title]));
